"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reselect = require("reselect");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faEdit = require("@fortawesome/pro-regular-svg-icons/faEdit");

var _faPlus = require("@fortawesome/pro-regular-svg-icons/faPlus");

var _faArrows = require("@fortawesome/pro-regular-svg-icons/faArrows");

var _faPlay = require("@fortawesome/pro-regular-svg-icons/faPlay");

var _faArrowsH = require("@fortawesome/pro-regular-svg-icons/faArrowsH");

var _core = require("@react-page/core");

var _peractoConfig = require("@peracto/peracto-config");

var _Save = require("./Save");

var _styled = require("./styled");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _Actions$Display = _core.Actions.Display,
    editMode = _Actions$Display.editMode,
    insertMode = _Actions$Display.insertMode,
    layoutMode = _Actions$Display.layoutMode,
    previewMode = _Actions$Display.previewMode,
    resizeMode = _Actions$Display.resizeMode;
var _Selectors$Display = _core.Selectors.Display,
    isEditMode = _Selectors$Display.isEditMode,
    isInsertMode = _Selectors$Display.isInsertMode,
    isLayoutMode = _Selectors$Display.isLayoutMode,
    isPreviewMode = _Selectors$Display.isPreviewMode,
    isResizeMode = _Selectors$Display.isResizeMode;
var Edit = (0, _core.connect)((0, _reselect.createStructuredSelector)({
  isEditMode: isEditMode
}), {
  editMode: editMode
})(function (_ref) {
  var isEditMode = _ref.isEditMode,
      editMode = _ref.editMode;
  return /*#__PURE__*/_react["default"].createElement("button", {
    title: "Edit",
    className: (0, _classnames["default"])('btn', {
      'btn-active': isEditMode
    }),
    "data-testid": "content-edit",
    onClick: function onClick() {
      var el = document.getElementById('editor-content-body');
      var position = el.scrollTop;
      editMode();
      setTimeout(function () {
        el.scrollTop = position;
      }, 200);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faEdit.faEdit
  }));
});
var Add = (0, _core.connect)((0, _reselect.createStructuredSelector)({
  isInsertMode: isInsertMode
}), {
  insertMode: insertMode
})(function (_ref2) {
  var isInsertMode = _ref2.isInsertMode,
      insertMode = _ref2.insertMode;
  return /*#__PURE__*/_react["default"].createElement("button", {
    title: "Add",
    className: (0, _classnames["default"])('btn', {
      'btn-active': isInsertMode
    }),
    "data-testid": "content-add",
    onClick: insertMode
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faPlus.faPlus
  }));
});
var Move = (0, _core.connect)((0, _reselect.createStructuredSelector)({
  isLayoutMode: isLayoutMode
}), {
  layoutMode: layoutMode
})(function (_ref3) {
  var isLayoutMode = _ref3.isLayoutMode,
      layoutMode = _ref3.layoutMode;
  return /*#__PURE__*/_react["default"].createElement("button", {
    title: "Move",
    className: (0, _classnames["default"])('btn', {
      'btn-active': isLayoutMode
    }),
    "data-testid": "content-move",
    onClick: function onClick() {
      var el = document.getElementById('editor-content-body');
      var position = el.scrollTop;
      layoutMode();
      setTimeout(function () {
        el.scrollTop = position;
      }, 200);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faArrows.faArrows
  }));
});
var Preview = (0, _core.connect)((0, _reselect.createStructuredSelector)({
  isPreviewMode: isPreviewMode
}), {
  previewMode: previewMode
})(function (_ref4) {
  var isPreviewMode = _ref4.isPreviewMode,
      previewMode = _ref4.previewMode;
  return /*#__PURE__*/_react["default"].createElement("button", {
    title: "Preview",
    className: (0, _classnames["default"])('btn', {
      'btn-active': isPreviewMode
    }),
    "data-testid": "content-preview",
    onClick: previewMode
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faPlay.faPlay
  }));
});
var Resize = (0, _core.connect)((0, _reselect.createStructuredSelector)({
  isResizeMode: isResizeMode
}), {
  resizeMode: resizeMode
})(function (_ref5) {
  var isResizeMode = _ref5.isResizeMode,
      resizeMode = _ref5.resizeMode;
  return /*#__PURE__*/_react["default"].createElement("button", {
    title: "Resize",
    className: (0, _classnames["default"])('btn', {
      'btn-active': isResizeMode
    }),
    "data-testid": "content-resize",
    onClick: resizeMode
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faArrowsH.faArrowsH
  }));
});

var Toolbar = function Toolbar(_ref6) {
  var onSave = _ref6.onSave;
  var config = (0, _peractoConfig.useConfig)();

  var _config$get = config.get('features', {}),
      content = _config$get.content;

  return /*#__PURE__*/_react["default"].createElement(_styled.Buttons, null, /*#__PURE__*/_react["default"].createElement(Edit, null), /*#__PURE__*/_react["default"].createElement(Add, null), /*#__PURE__*/_react["default"].createElement(Resize, null), /*#__PURE__*/_react["default"].createElement(Move, null), /*#__PURE__*/_react["default"].createElement(Preview, null), content !== null && content !== void 0 && content.indexContent ? /*#__PURE__*/_react["default"].createElement(_Save.SaveAndIndex, {
    onSave: onSave
  }) : /*#__PURE__*/_react["default"].createElement(_Save.Save, {
    onSave: onSave
  }));
};

var _default = Toolbar;
exports["default"] = _default;